export class OmsWallpaper {
    oms: HTMLElement;
    zone: string;
    isRoot: string;
    screen_width: number;
    breakpointIndex: any;
    breakpoints: Array<number>;
    network_code: number;
    adpositions: any;
    oms_site_display: string;
    oms_site_mobile: string

    constructor() {
        this.oms = document.querySelector('[data-oms]');

        if (typeof this.oms === 'undefined') {
            return;
        }

        this.adpositions = [];
        this.zone = this.oms.dataset.omsZone ? this.oms.dataset.omsZone : '';
        this.isRoot = this.oms.dataset.isRoot ? this.oms.dataset.isRoot : '0';
        this.screen_width = typeof document.documentElement != 'undefined' ? document.documentElement.clientWidth : window.innerWidth;
        this.breakpointIndex = 0;
        this.oms_site_display = 'rmsi.radioffn.de';
        this.oms_site_mobile = 'mew.rmsi.radioffn.de';
        this.breakpoints = [480, 800, 1024, 1180];
        this.network_code = this.screen_width < 800 ? 8635 : 5766;

        this.init();
    }

    init() {
        // @ts-ignore
        if (typeof SDG !== 'undefined') {
            this.setAdPositions();
            this.setBreakpointIndex();
            // @ts-ignore
            SDG.Publisher.setZone(this.zone);
            this.registerSlots();
            // @ts-ignore
            SDG.Publisher.finalizeSlots();
        }
    }

    setBreakpointIndex(this: OmsWallpaper) {
        for (let i = 0; i < this.breakpoints.length; i++) {
            if (this.screen_width >= this.breakpoints[this.breakpoints.length - 1]) {

                this.breakpointIndex = this.breakpoints.length;
                return this.breakpoints.length;

            } else if (this.screen_width < this.breakpoints[i]) {

                this.breakpointIndex = i;
                return i;
            }
        }
    }

    setAdPositions(this: OmsWallpaper) {
        // @ts-ignore
        let adPositions = [
            {   // < 480
                topmobile: {
                    container: 'pos1',
                    dimensions: [320, 50]
                },
                interstitial: {
                    container: 'ist',
                    dimensions: [1, 1]
                }
            },
            {   // < 800
                topmobile: {
                    container: 'pos1',
                    dimensions: [468, 60]
                },
                interstitial: {
                    container: 'ist',
                    a: [1, 1]
                }
            },
            {   // < 1024
                banner: {
                    container: 'superbanner',
                    dimensions: [728, 90],
                    special: '_nowp'
                },
                "out-of-page": {
                    container: 'outofpage',
                    dimensions: {}
                }
            },
            {   // < 1180
                banner: {
                    container: 'superbanner',
                    dimensions: [728, 90],
                },
                "out-of-page": {
                    container: 'outofpage',
                    dimensions: {}
                }
            },
            {   // >= 1180
                banner: {
                    container: 'superbanner',
                    dimensions: [728, 90]
                },
                sky: {
                    container: 'skyscraper',
                    dimensions: [[120, 600], [160, 600], [200, 600]]
                },
                "out-of-page": {
                    container: 'outofpage',
                    dimensions: {}
                }
            }
        ];

        if (this.isRoot === '1') {
            // @ts-ignore
            adPositions[1].interstitial = {
                container: 'ist',
                dimensions: [1, 1]
            };
            // @ts-ignore
            adPositions[2] = {
                banner: {
                    container: 'superbanner',
                    dimensions: [728, 90],
                    special: '_nowp'
                },
                // @ts-ignore
                rectangle: {
                    container: 'rectangle',
                    dimensions: [300, 250]
                },
                "out-of-page": {
                    container: 'outofpage',
                    dimensions: {}
                }
            };
            // @ts-ignore
            adPositions[3] = {
                banner: {
                    container: 'superbanner',
                    dimensions: [728, 90]
                },
                // @ts-ignore
                rectangle: {
                    container: 'rectangle',
                    dimensions: [300, 250]
                },
                "out-of-page": {
                    container: 'outofpage',
                    dimensions: {}
                }
            };
        }

        this.adpositions = adPositions;

        return this.adpositions;
    }

    registerSlots(this: OmsWallpaper) {
        let a;
        for (a in this.adpositions[this.breakpointIndex]) {
            if (this.adpositions[this.breakpointIndex].hasOwnProperty(a)) {
                //@ts-ignore
                SDG.Publisher.registerSlot(a, this.adpositions[this.breakpointIndex][a].container).load();
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new OmsWallpaper();
});